var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"smartsticky",staticClass:"smart-sticky-header",class:{ sticky: _vm.isSticky },style:({ top: _vm.itemHeight + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }